module.exports = __webpack_public_path__ + "static/img/banner4.dc1658fe.jpg";